import { getGaCookieValue } from 'analytics/utils/getGaCookieValue/getGaCookieValue'
import { userAgent as getUserAgent } from 'next/server'
import type { Session } from 'session/src/types/session'
import type { InitResponse } from '../types/AIResponseTypes'

interface ChatbotInitFetcherOptions {
	countryISO: string
	externalId: Session['externalId']
	sessionId: string
	token: Session['token']
	languageISO: string
}

export const chatBotInitFetcher = async (
	url: URL,
	{
		countryISO,
		externalId,
		sessionId,
		token,
		languageISO,
	}: ChatbotInitFetcherOptions
): Promise<InitResponse> => {
	const userAgent = getUserAgent({
		headers: {
			get: () => window.navigator.userAgent,
		} as unknown as Headers,
	})

	return (
		await fetch(url.href, {
			next: { revalidate: 0 },
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				queryParams: {
					sessionId,
					customParams: {
						externalId,
						languageCode: languageISO,
						countryCode: countryISO,
						source: 'chat',
						isOutlet: false,
						userPseudoId: getGaCookieValue(),
						gaSessionId: window.analytics.sessionId,
						os: userAgent.os.name,
					},
				},
			}),
		})
	).json()
}
